import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiMarketplaceService} from "./api-marketplace.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers:[ApiMarketplaceService]
})
export class ApiMarketplaceModule { }
